import { AbstractModel } from '../../shared/abstract.model';

/**
 * Model describing notification object
 */
export class NotificationEntry extends AbstractModel {
  /**
   * User id
   */
  userId: string;
  /**
   * Long definition
   */
  description: string;
  /**
   * Priority of the notification
   */
  status: string;
  /**
   * ElementId
   */
  mapObjectId: string;
  /**
   * Comments
   */
  comments: any[];
  userName: string;
  state: 'new' | 'updated' | undefined;

  constructor() {
    super();
    this.id = null;
  }
}

